import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import styled from "styled-components";
import FormControl from "@mui/material/FormControl";
import LoadingButton from "@mui/lab/LoadingButton";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import { useKeycloak } from "@react-keycloak/web";
import Input from "../../../shared-components/form/Input";
import { clientAxios8080, clientAxios6060 } from "../../../configs/axios";
import Swal from 'sweetalert2';

const Field = styled(Box)`
  width: 100%;
  margin: 15px 0;
  & label {
    display: inline-block;
    margin-bottom: 5px;
    font-size: 13px;
    font-weight: 500;
  }
`;

export default function AddFolder({
  updateDoc,
  idFile,
  idFileStatus,
  handleClose,
  folderId,
  tabSelectedHandle,
  getDetailsFile,
}) {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    watch,
  } = useForm();
  const { keycloak } = useKeycloak();

  const [loading, setLoading] = useState(false);
  const [isFormComplete, setIsFormComplete] = useState(false);
  const [valid,setValid]  = useState(false);
  const forbiddenExtensions = ['.html', '.exe', '.js', '.json', '.crt', '.jar', '.rdp','.sql','.dmg'];
  
  const isExtensionForbidden = (fileName) => {
    const fileExtension = fileName.slice(fileName.lastIndexOf('.')).toLowerCase();
    console.log(fileExtension)
    return forbiddenExtensions.includes(fileExtension);
  };
  
  React.useEffect(() => {
    const subscription = watch((value) => {
      if (value.file) {
        const forbiddenFiles = Array.from(value.file).filter((file) =>
          isExtensionForbidden(file.name)
        );

        if (forbiddenFiles.length > 0) {
          setValid(true)
          setIsFormComplete(false);
        }else {
          setValid(false)
          setIsFormComplete(true);
        }
      }else{
        setIsFormComplete(false);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const onSubmit = async (dataForm) => {
    setLoading(true);
    if (updateDoc) {
      const formData = new FormData();
      formData.append("file", dataForm.file[0]);

      formData.forEach((value, key) => {
        console.log(`Campo: ${key}, Valor: ${value}`);
      });

      clientAxios8080
        .put(
          `/ms-repositorio/file/update/multipart/?idFile=${idFile}&idUser=${keycloak?.tokenParsed?.sub}&isPrivate=${dataForm.status}&idFileStatus=${idFileStatus}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          console.log("Respuesta:", response.data);
          tabSelectedHandle(folderId);
          getDetailsFile(response.data.data.id);
          handleClose();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } else {
      try {
        // Crear una lista de promesas para cada archivo
          const formData = new FormData();
          Array.from(dataForm.file).forEach((file, index) => {
            formData.append("file", file);
          });
          formData.append("idUser", keycloak?.tokenParsed?.sub);
          formData.append("idFolderRepository", folderId);
          formData.append("isPrivate", false);
          formData.append("flagisAuth", false);

          // Retornar la promesa para cada archivo
        await clientAxios8080.post("/ms-repositorio/file/upload/multipart/", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }).then(response =>{
          if (response.status === 200) {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Documentos agregados exitosamente',
              showConfirmButton: false,
              timer: 4200,
            });
          
          } else {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: 'Error al cargar archivos',
              text:  'Hubo un error al procesar la solicitud.',
            });
          }
        }).catch(error =>{
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Error al cargar archivos',
            text: error || 'Hubo un error al procesar la solicitud.',
          });
        });
        
        // Llamar a las funciones adicionales si es necesario
        tabSelectedHandle(folderId);
        handleClose();
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  return (
    <Box>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Field>
          <label>Seleccione el archivo</label>
          <Input
            type="file"
            register={register}
            errors={errors}
            keyName="file"
            required
          />{valid && (
          <label >Existen archivos con extensión inválida.</label>
        )}
        </Field>
        <LoadingButton
          variant="contained"
          color="success"
          type="submit"
          loading={loading}
          fullWidth
          disabled={!isFormComplete}
        >
          <span>Subir Documento</span>
        </LoadingButton>
      </form>
    </Box>
  );
}
